<template>
  <div class="card" :class="modifiers">
    <button
      type="submit"
      class="card__toggle"
      @click="toggle"
    >
      <BaseTitle
        v-if="title"
        v-bind="title"
        class="card__name"
      />
      <BaseIcon
        name="tick"
        class="card__tick"
      />
    </button>
    <div v-if="isOpen" class="card__content">
      <BaseText
        v-if="note"
        v-bind="note"
        class="card__note"
      />
      <div class="card__fieldset">
        <BaseTitle
          v-if="label"
          v-bind="label"
          class="card__label"
        />
        <div class="card__fields">
          <FieldMeter
            v-model="meter.current"
            :min="Number(meter.previous)"
            :scale="Number(meter.scale)"
            :disabled="readonly"
            class="card__field card__field_current"
          />
          <BaseField
            type="text"
            :label="$t('fields.meterPrevLabel')"
            :value="meter.previous"
            disabled="true"
            class="card__field card__field_previous"
          />
          <BaseField
            type="text"
            :label="$t('fields.meterDateLabel')"
            :value="date"
            disabled="true"
            class="card__field"
          />
        </div>
      </div>
      <div v-if="!readonly" class="card__actions">
        <BaseButton
          :text="$t('actions.sendInfo')"
          :disabled="isButtonDisabled"
          @click="submit"
        />
      </div>
    </div>
  </div>
</template>

<script>
import BaseIcon from '@/components/BaseIcon.vue';
import BaseText from '@/components/BaseText.vue';
import BaseTitle from '@/components/BaseTitle.vue';
import BaseField from '@/components/BaseField.vue';
import BaseButton from '@/components/BaseButton.vue';
import FieldMeter from '@/components/FieldMeter.vue';

export default {
  name: 'MeterCard',
  components: {
    BaseIcon,
    BaseText,
    BaseTitle,
    BaseField,
    BaseButton,
    FieldMeter,
  },
  props: {
    meter: {
      type: Object,
      required: true,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isOpen: false,
    };
  },
  computed: {
    modifiers() {
      return {
        card_open: this.isOpen,
      };
    },
    title() {
      return {
        text: `${this.meter.accountCode}&emsp;${this.meter.name}`,
        isNormal: true,
        isBright: true,
        tag: 'b',
      };
    },
    label() {
      return {
        text: this.$t('fields.meterNumber', { number: this.meter.label }),
        isNormal: true,
      };
    },
    date() {
      return this.meter.date?.toLocaleDateString(this.$i18n.locale) || '';
    },
    note() {
      return {
        text: this.$t('texts.wrongInfo'),
        size: 's',
        theme: 'note',
      };
    },
    isButtonDisabled() {
      return !this.meter.isComplete();
    },
  },
  methods: {
    toggle() {
      this.isOpen = !this.isOpen;
    },
    submit() {
      this.$emit('submit');
    },
  },
};
</script>

<style lang="stylus">
.card
  display block
  background-color #fff
  box-shadow 0 0.6em 1em -0.5em alpha($c_primary, 20%)
  border-radius 0.2em

  &__toggle
    display flex
    align-items center
    width 100%
    padding 2em
    background none
    text-align left
    border 0
    margin 0
    outline none

  &__name
    font-size 1.4em

  &__tick
    width 1.1em
    margin-left auto
    margin-right 1em
    color $c_primary
    transition transform 300ms cubic-bezier(.455,.03,.515,.955)
    ~/_open &
      transform rotateX(180deg)

  &__toggle
  &__content
    padding-left 1.5em
    padding-right @padding-left

  &__content
    padding-bottom 1.5em
    &:before
      content ''
      display block
      height 0.1em
      background-color #DCDEE5
      margin-bottom @padding-bottom

  &__actions
    margin-top 1em

  &__note
    margin-bottom 2em

  &__fieldset
    margin-top 1em
    :first-child
      margin-top 0

  &__label
    display block
    margin-bottom 1em

  &__fields
    display flex
    justify-content space-between

  &__field
    flex-grow 1
    flex-basis 0
    max-width 32%
    &_previous
      order -1
      .field_invalid:not(.field_focused) + &
        .field__el
          box-shadow inset 0 0 0 0.1em $c_error
</style>
